// i18n area 'common' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.sk-SK.meta.json.
import type { enUS } from './common'

export const skSK: typeof enUS = {
  nav: {
    home: 'Domov',
    vms: 'Virtuálne stroje',
    templates: 'Šablóny',
    importVms: 'Importovať VM',
    containers: 'Kontajnery',
    containersApps: 'Aplikácie',
    containersPods: 'Pody',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Obrazy OCI',
    containersOciRegistries: 'Registre OCI',
    containersCtTemplates: 'Šablóny CT',
    networkServices: 'Sieťové služby',
    firewall: 'Firewall',
    checkpoints: 'Checkpointy',
    backup: 'Zálohovanie',
    monitoring: 'Monitorovanie',
    cluster: 'Klaster',
    clusterSettings: 'Globálne nastavenia',
    clusterNodes: 'Uzly',
    clusterDevices: 'Zdroje USB a PCIe',
    clusterFederation: 'Federácia',
    network: 'Sieť',
    overlayNetworks: 'Overlay siete',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Úložisko',
    data: 'Údaje',
    storages: 'Úložiská',
    hci: 'Hyperkonvergencia',
    ceph: 'Ceph',
    system: 'Systém',
    tasks: 'Úlohy',
    events: 'Udalosti',
    audit: 'Audit',
    diagnostics: 'Diagnostika',
    notifications: 'Oznámenia',
    proximity: 'TVirt Proximity',
    users: 'Používatelia a skupiny',
    groups: 'Skupiny',
    mfa: 'MFA',
    realms: 'Realmy a SSO',
    rbac: 'Roly a oprávnenia',
    credentials: 'Poverenia',
    scopes: 'Scope',
    tags: 'Značky',
    explorer: 'Prieskumník',
    licensing: 'Licencia',
    information: 'Informácie'
  },
  mode: {
    light: 'Svetlý',
    dark: 'Tmavý',
    system: 'Systém',
    tooltip: 'Motív'
  },
  language: {
    tooltip: 'Jazyk'
  },
  langRegion: {
    europe: 'Európa',
    northAmerica: 'Severná Amerika',
    southAmerica: 'Južná Amerika',
    asia: 'Ázia'
  },
  notFound: {
    title: 'Stránka sa nenašla',
    body: 'Táto adresa nezodpovedá žiadnej stránke TVirt — mohla sa presunúť pri aktualizácii, alebo je odkaz starý.',
    backHome: 'Späť na Domov'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Celý klaster',
    noChildren: 'Tu nie je žiadny pod-scope',
    recursive: 'Zahrnúť potomkov',
    collapse: 'Zbaliť panel scopov',
    openPicker: 'Prehľadávať scopy',
    up: 'O úroveň vyššie',
    countTooltip: '{direct} v tomto scope · {total} spolu s potomkami'
  },
  search: {
    tooltip: 'Hľadať (⌘K)',
    placeholder: 'Hľadajte VM, siete, úložiská…',
    empty: 'Žiadne výsledky',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Nedávne',
      shortcuts: 'Skratky',
      actions: 'Akcie',
      goTo: 'Prejsť na'
    },
    kind: {
      catalog: 'Katalóg',
      scope: 'Scope',
      node: 'Uzol'
    },
    footer: {
      navigate: 'navigácia',
      open: 'otvoriť',
      close: 'zavrieť'
    },
    actions: {
      createVm: 'Vytvoriť VM…',
      uploadIso: 'Nahrať ISO…',
      clusterSettings: 'Nastavenia klastra',
      consoleOf: 'Prejsť na konzolu {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikácie a systémové kontajnery (CT) s ich obrazmi OCI, registrami a šablónami — spravované popri vašich VM.',
    sectionSummary_vms: 'Virtuálne stroje a ich šablóny — životný cyklus, snímky, migrácia a konzola.',
    sectionSummary_storages: 'Úložiská, v ktorých žijú disky, obrazy a metadáta VM.',
    sectionSummary_catalogs: 'Domov súborových artefaktov klastra: obrazy ISO, šablóny CT a VM a archívy OCI, usporiadané do katalógov.',
    sectionSummary_overlay: 'Overlay siete VXLAN medzi uzlami klastra.',
    sectionSummary_fabric: 'Inventár fyzickej siete — prepínače, porty, LAGG a logické siete.',
    sectionSummary_ipam: 'Adresovanie odvodené zo sietí fabric a overlay: kto drží každú adresu.',
    sectionSummary_services: 'Servery DHCP a DNS odvodené zo sieťového registra.',
    sectionSummary_ceph: 'Klastre Ceph spravované na uzloch TVirt.',
    sectionSummary_hci: 'Hyperkonvergované úložiskové technológie na uzloch TVirt.',
    sectionSummary_cluster: 'Uzly, členstvo a nastavenia klastra.',
    containers: 'Systémové kontajnery sú v roadmape — táto sekcia ich bude hostiť.',
    containersApps: 'Kontajnerizované aplikácie sú v roadmape — táto oblasť ich bude hostiť.',
    containersPods: 'Pody združujú kontajnery zdieľajúce sieť a zväzky — inštancie sú aplikácie.',
    containersCt: 'Systémové kontajnery (CT) sú v roadmape — táto oblasť ich bude hostiť.',
    multiscsi: 'TVStor MultiSCSI je v roadmape — táto oblasť ho bude hostiť.',
    clusterFederation: 'Federácia medzi klastrami TVirt je v roadmape — táto oblasť ju bude hostiť.',
    containersOciImages: 'Obrazy OCI sú v roadmape — táto oblasť ich bude hostiť.',
    containersOciRegistries: 'Registre OCI sú v roadmape — táto oblasť ich bude hostiť.',
    containersCtTemplates: 'Šablóny CT sú v roadmape — táto oblasť ich bude hostiť.',
    importVms: 'Importéry ESXi a Proxmox prídu sem: konverzia hosťov a hromadná migrácia do TVirt.',
    backup: 'Integrované zálohovanie prichádza s verziou 6.2: deduplikované content-addressed repozitáre, inkrementálne zálohy CBT, okná nemennosti a replikácia repo-to-repo.',
    monitoring: 'Dashboardy súperenia o zdroje naprieč klastrom (cpu.ready, tlak PSI, integrované výstrahy) sú na ceste — rovnaké metriky dnes žijú v detailoch každej VM.'
  },
  home: {
    welcome: 'Prihlásili ste sa ako: {name}',
    subtitle: 'Váš klaster TVirt na jeden pohľad.',
    loadError: 'Prehľad sa nepodarilo načítať — je backend TVirt dostupný?',
    health: {
      ok: 'Všetko v poriadku',
      warning: 'Pozor',
      critical: 'Kritické problémy'
    },
    reason: {
      'node-down': '{subject} je vypnutý',
      'node-stale': '{subject} sa už nejaký čas neozval',
      'node-maintenance': '{subject} v údržbe',
      'tasks-failed': {
        one: '{n} zlyhaná úloha za posledných 24 h',
        few: '{n} zlyhané úlohy za posledných 24 h',
        many: '{n} zlyhanej úlohy za posledných 24 h',
        other: '{n} zlyhaných úloh za posledných 24 h'
      },
      'storage-degraded': 'úložisko {subject} degradované',
      'storage-error': 'úložisko {subject} v chybovom stave',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store klastra je nedostupný',
      'license-absent': 'žiadna licencia — nové VM sa nemôžu spustiť',
      'license-expired': 'licencia vypršala — nové VM sa nemôžu spustiť',
      'license-exceeded': 'prekročený limit licencie — nové VM sa nemôžu spustiť',
      'failover-reserve-eroded': 'rezerva failoveru je takmer vyčerpaná',
      'failover-reserve-exhausted': 'rezerva failoveru je vyčerpaná — nové VM sa nemôžu spustiť',

      'oci-cache-nearly-full': 'cache OCI na {subject} je takmer plná — digesty sa odstraňujú ručne',
      'oci-cache-full': 'cache OCI na {subject} je plná — žiadny pull neuspeje, kým neodstránite niektoré digesty',
      'config-replica-empty': 'replika konfigurácie na {subject} je PRÁZDNA — uzol nemá konfiguráciu klastra, kým replikácia neuspeje',
      'config-replica-stalled': 'replikácia konfigurácie na {subject} stojí — lokálna kópia zaostáva za konfiguráciou klastra'
    },
    staleChip: 'Neaktuálne údaje',
    staleAsOf: 'posledná replika {time}',
    zone: {
      nodes: 'Uzly',
      failoverReserve: 'Rezerva failoveru',
      capacity: 'Kapacita',
      workload: 'Pracovná záťaž',
      protection: 'Ochrana',
      activity: 'Nedávna aktivita'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerva neporušená',
        eroded: 'Rezerva takmer vyčerpaná',
        exhausted: 'Rezerva vyčerpaná',
        unknown: 'Rezerva neznáma'
      },
      tolerate: {
        one: 'toleruje stratu {n} uzla',
        few: 'toleruje stratu {n} uzlov',
        many: 'toleruje stratu {n} uzla',
        other: 'toleruje stratu {n} uzlov'
      },
      usedOf: 'využité: {used} / {allowed} GiB',
      keepFree: 'voľné pre failover: {n} GiB',
      expendable: 'z toho obetovateľné za prevádzky: {n}',
      headroom: 'ešte možno spustiť {n} GiB',
      short: 'rezerve chýba: {n} GiB — nové VM sa nemôžu spustiť',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Stránky veľkosti {size} — využité: {used} / {allowed}',
        keepFree: 'voľné pre failover: {keep}',
        headroom: 'ešte spustiteľné: {n}',
        short: 'chýbajúce v rezerve: {n} — nové VM s obrovskými stránkami sa nemôžu spustiť'
      },
      worstCase: 'najhorší prípad: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Žiadny uzol zatiaľ nedeklaroval pamäť — rezervu nemožno vypočítať a žiadne spustenie sa neodmieta.',
      reason: {
        attestedDown: 'atestovane vypnutý',
        maintenance: 'v údržbe',
        unreachable: 'nedostupný',
        capacityUnknown: 'pamäť nedeklarovaná'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: 'jadrá: {cores} / vlákna: {threads}',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktívna VM',
        few: '{n} aktívne VM',
        many: '{n} aktívnej VM',
        other: '{n} aktívnych VM'
      },
      activeVmsUnknown: 'aktívne VM neznáme',
      lastSeen: 'naposledy videný {time}',
      neverSeen: 'nikdy nevidený',
      down: 'Vypnutý',
      maintenance: 'Údržba',
      stale: 'Nedostupný'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'alokované: {n} GiB',
      reserve: 'rezerva {n} GiB',
      unobserved: 'kapacita zatiaľ nepozorovaná',
      empty: 'Zatiaľ žiadne úložisko'
    },
    workload: {
      vms: 'Virtuálne stroje',
      apps: 'Aplikácie',
      services: 'Sieťové služby',
      empty: 'Zatiaľ nič',
      phasesUnknown: 'rozdelenie podľa fázy nie je k dispozícii'
    },
    protection: {
      none: 'Nie je nakonfigurovaný žiadny cieľ záloh — chráňte svoju konfiguráciu.',
      configure: 'Nakonfigurovať checkpointy',
      noRuns: 'Zatiaľ nebol vytvorený žiadny checkpoint.',
      last: 'Posledný checkpoint',
      onTarget: 'na {target}',
      viewAll: 'Checkpointy'
    },
    activity: {
      empty: 'Žiadna nedávna aktivita',
      failed24: {
        one: '{n} zlyhaná za 24 h',
        few: '{n} zlyhané za 24 h',
        many: '{n} zlyhanej za 24 h',
        other: '{n} zlyhaných za 24 h'
      },
      viewAll: 'Zobraziť všetky úlohy'
    }
  },
  notes: {
    title: 'Poznámky',
    tabEdit: 'Upraviť',
    tabPreview: 'Ukážka',
    placeholder: 'Voľné poznámky operátora — Markdown sa vykresľuje v ukážke',
    empty: 'Žiadne poznámky',
    tooLarge: 'Poznámky prekračujú limit 64 KiB',
    saveError: 'Poznámky sa nepodarilo uložiť'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Odpoveď backendu obsahuje hodnotu, ktorú toto rozhranie nepozná: {field}={value} — aktualizujte webui na verziu backendu.',
    contractErrorItems: 'Nečitateľné objekty tohto zoznamu ({field}={value}): {count} — nezobrazujú sa.',
    staleHint: 'Store nie je dostupný — toto je replika konfigurácie tohto uzla; stav flotily je neznámy.',
    staleStateAge: 'stav k {time}',
    staleStateNever: 'stav nebol zo store nikdy prijatý: vidíte len pozorovania tohto uzla',
    staleStateTooltip: 'Store klastra nie je dostupný: pozorovaný stav (fáza, uzol, agent) pochádza z repliky stavu tohto uzla a zodpovedá poslednému úspešnému čítaniu zo store — môže byť zastaraný.',
    noPermission: 'Na túto akciu nemáte oprávnenie',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'Akcia stále prebieha: výsledok zatiaľ nie je známy',
    staleWrite: 'Niekto iný tento objekt zmenil, kým ste ho upravovali — nič sa nezapísalo. Znova načítajte a zopakujte úpravu na aktuálnom stave.',
    staleReload: 'Znova načítať',
    preview: 'Náhľad',
    previewTitle: 'Náhľad výsledku',
    previewNothingWritten: 'Simulované na serveri — nič sa nezapísalo.',
    previewChanged: 'Zvýraznené sú hodnoty, ktoré by sa zmenili.'
  },
  context: {
    copySelection: 'Kopírovať vybraný text'
  },
  crud: {
    create: 'Vytvoriť',
    viewDetails: 'Zobraziť detaily',
    viewOrEdit: 'Zobraziť alebo upraviť',
    selected: 'vybrané',
    viewUsingVms: 'Zobraziť VM používajúce tento zdroj',
    clearSelection: 'Zrušiť výber',
    deleteSelected: 'Odstrániť vybrané',
    bulkConfirmBody: {
      one: 'Odstrániť {count} vybranú položku? Ak je chránená, bude nahlásená a ponechaná.',
      few: 'Odstrániť {count} vybrané položky? Chránené položky budú nahlásené a ponechané.',
      many: 'Odstrániť {count} vybranej položky? Chránené položky budú nahlásené a ponechané.',
      other: 'Odstrániť {count} vybraných položiek? Chránené položky budú nahlásené a ponechané.'
    },
    bulkDeleted: 'odstránené',
    bulkRefused: 'odmietnuté',
    fieldId: 'ID',
    createdAt: 'Vytvorené',
    updatedAt: 'Aktualizované',
    immutableField: 'Nastavené pri vytvorení — contract jeho zmenu nedovoľuje',
    immutableScope: 'Scope sa priraďuje pri vytvorení; niektoré zdroje sa presúvajú vyhradenou akciou',
    observedField: 'Pozorovaný stav — hlásený platformou, nemožno ho upraviť'
  }
}
